export default __webpack_public_path__ + "static/media/hmd_l1.7cac39a6.png";